// Canonical loading skeleton (see CLAUDE.md "Loading / error / empty
// conventions": first load renders skeleton table rows or rectangles).
//
// - `variant="rows"` renders `rows` pulsing bars; size the bars with
//   `rowClassName` (default `h-6`) and space/pad the container with
//   `className`.
// - `variant="block"` renders a single pulsing rectangle sized via
//   `className` — compose several for bespoke shapes (see JobDrawer).
const PULSE = 'animate-pulse rounded bg-slate-100';

export function Skeleton({
  variant,
  rows = 4,
  rowClassName = 'h-6',
  className,
  'data-testid': testId,
}: {
  variant: 'rows' | 'block';
  rows?: number;
  rowClassName?: string;
  className?: string;
  'data-testid'?: string;
}) {
  if (variant === 'block') {
    return <div data-testid={testId} className={`${PULSE}${className ? ` ${className}` : ''}`} />;
  }
  return (
    <div data-testid={testId} className={className}>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className={`${PULSE} ${rowClassName}`} />
      ))}
    </div>
  );
}
